import gsap from 'gsap';

export const scrollTo = async (
    $element,
    {
        offset = 0,
        duration = 0.4,
        onComplete = () => {},
        alignment = 'top',
        scroller = null,
    } = {}
) => {
    const timeline = gsap.timeline({
        paused: true,
    });

    if (scroller === null) {
        scroller = window;
    }

    const offsetForAlignment = (() => {
        if (alignment === 'bottom') {
            return (
                $(scroller).outerHeight()
                - $element.outerHeight()
            );
        }

        if (alignment === 'center') {
            return (
                0.5 * (
                    $(scroller).outerHeight()
                    - $element.outerHeight()
                )
            );
        }

        return 0;
    })();
    const scrollMarginTop = (() => {
        if (alignment !== 'top' || !$element.length) {
            return 0;
        }

        return parseFloat(
            window.getComputedStyle($element.get(0)).scrollMarginTop
        ) || 0;
    })();

    const offsetY = (
        offsetForAlignment
        + offset
        + scrollMarginTop
    );

    timeline.to(
        scroller,
        {
            duration,
            scrollTo: {
                y: $element,
                offsetY,
            },
            onComplete,
        }
    );

    await timeline.play();
};
